import { Pipe, PipeTransform } from '@angular/core';

const ACRONYMS = new Set([
  'AG',
  'SE',
  'SA',
  'NV',
  'PLC',
  'LP',
  'LLC',
  'INC',
  'LTD',
  'CO',
  'BMW',
  'SAP',
  'ETF',
  'CEO',
  'CFO',
  'IPO',
  'USA',
  'EU',
  'UK',
  'AI',
  'IT',
  'BASF',
  'LVMH',
  'IBM',
  'AMD',
  'ASML',
  'HSBC',
  'UBS',
  'DHL',
  'VW',
  'RWE',
  'EON',
  'MTU',
  'DWS',
  'KGaA',
]);

@Pipe({
  name: 'smartTitleCase',
  standalone: true,
})
export class SmartTitleCasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .split(/\s+/)
      .map((word) => {
        const upper = word.toUpperCase();
        if (ACRONYMS.has(upper) || ACRONYMS.has(word)) {
          // Preserve the canonical casing from the set
          for (const a of ACRONYMS) {
            if (a.toUpperCase() === upper) return a;
          }
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
}
